import BulkSearchField from '@extension/context/content/components/bt-bulk-dashboard/bulk-search-field';
import LazyLoadingVirtuoso from '@extension/context/content/components/bt-bulk-dashboard/lazy-loading-virtuoso';
import { Close } from "@mui/icons-material";
import { IconButton, Tooltip } from "@mui/material";
import { Stack } from "@mui/system";
import { getCampaignsWithPendingMessagesIds } from '@common-reducers/CampaignSelectors';
import { DBBoardsThunks, DBCampaignThunks, campaignsSelectByQuery } from "@common-reducers/DBServiceThunks";
import { useEffect, useState } from "react";
import { mainSliceActions } from "@common/reducers/MainReducer";
import { useAppDispatch, useAppSelector } from "@common-reducers/hooks/store.hook";
import PendingCampaignRow from './pending-campaign-row';
import classes from "./scheduled-contact-list.module.scss";
import { useTranslation } from 'react-i18next';
import { namespace } from '@common-config/constants';

type Props = {}

export default function ScheduledCampaignsList({ }: Props) {
    const dispatch = useAppDispatch();
    const { t } = useTranslation(namespace);

    const [searchTerm, setSearchTerm] = useState("");

    const campaignIdsWithUnsentMessagesArray = useAppSelector((state) => getCampaignsWithPendingMessagesIds(state))

    const closePanel = () => {
        dispatch(mainSliceActions.toggleCalendarView(false));
    };


    useEffect(() => {
        dispatch(DBBoardsThunks.find({
            deleted: false,
            type: 'audience',
            $paginate: false,
        }))
    }, [])


    return (
        <div>
            <Stack className={classes.header} direction="row" justify-content="space-between" spacing={1}>
                <BulkSearchField
                    searchTerm={searchTerm}
                    setSearchTerm={setSearchTerm}
                    placeHolderString={t('campaign.searchPlaceholder')}
                />
                <Tooltip title="Close scheduled messages" arrow placement="top">

                    <IconButton style={{ cursor: "pointer", marginRight: "8px", padding: 0, color: 'var(--color-primary)' }} onClick={closePanel}>

                        <Close />

                    </IconButton>
                </Tooltip>
            </Stack>
            <div className={classes.contactListContainer}>
                <Stack sx={{ borderRadius: '12px', }}>
                    <LazyLoadingVirtuoso
                        height={700}
                        isFullWidth={true}
                        rowHeightString='112px'
                        filterObj={{
                            $or: [
                                { 'template.name': { $regex: searchTerm, $options: 'i' } },
                                { 'template.message': { $regex: searchTerm, $options: 'i' } }
                            ],
                            _id: { $in: campaignIdsWithUnsentMessagesArray }
                        }}
                        DBThunks={DBCampaignThunks}
                        DBReducer={state => state.DBCampaignReducer}
                        selectByQuery={campaignsSelectByQuery}
                        Component={PendingCampaignRow}
                    />
                </Stack>
            </div>
        </div>
    )
}